<template>
  <div class="main">
    <h1>Create fabric order dashboard</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
